import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { customersQueries } from "../../../shared/queries/customers.queries";
import { RouteError } from "../../../shared/components/RouteError";
import { RoutePending } from "../../../shared/components/RoutePending";
import { listSearch } from "../../../shared/utils/pagination-search";

const searchSchema = listSearch.extend({ customerId: z.string().optional() });

export const Route = createFileRoute("/app/admin/fsm/document-types/")({
  validateSearch: searchSchema,
  errorComponent: ({ error }) => <RouteError error={error} />,
  pendingComponent: RoutePending,
  loader: async ({ context }) => {
    const customers = await context.queryClient.ensureQueryData(
      customersQueries.list(),
    );
    return { customers };
  },
});
